<template>

    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ product.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}`">
                            Карточка
                        </CNavItem>
                        <CNavItem active>
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/categories`">
                            Категории
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/options`">
                            Опции
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/variants`">
                            Варианты
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="product.title"
                            label="Название"
                            placeholder="Введите название продукта"
                        />
                        <div id="product-picture">
                        <CRow v-if="product.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="6" class="col-form-label"><CImg
                                :src="pictureUrl"
                                class="m2"
                                width="200" />
                            </CCol>
                            <CCol sm="3" class="col-form-label">
                                <CButton
                                    color="danger"
                                    class="ml-3"
                                    @click="deletePicture(product.picture)">Удалить</CButton>
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"
                        />
                        </div>
                        <CTextarea
                            v-model="product.description"
                            label="Описание"
                            placeholder="Краткое описание продукта (не более 255 символов)"
                        />

                        <CInput
                            v-model="product.cart_button_title"
                            label="Кнопка «В корзину», текст"
                            placeholder="Текст на кнопке"
                        />
                        <CInput
                            v-model="product.cart_button_link"
                            label="Кнопка «В корзину», ссылка"
                            placeholder="Ссылка кнопки"
                        />
                        
                        <CInput
                            v-model="product.lead_time"
                            label="Время выполенния"
                        />
                        <CInput
                            v-model="product.quantity"
                            label="Количество (шт)"
                        />
                        <CInput
                            v-model="product.composition"
                            label="Состав"
                            placeholder="Состав продукта (не более 255 символов)"
                        />
                        <CInput
                            v-model="product.allergens"
                            label="Содержит"
                            placeholder="Аллергены, если есть (не более 255 символов)"
                        />
                        <CInput
                            v-model="product.options_limit"
                            label="Доступное количество опций (шт)"
                            placeholder="12"
                        />
                        <CInput
                            v-model="product.price"
                            label="Цена"
                        />
                        <CSelect
                            :value.sync="product.vat"
                            :horizontal="true"
                            :options="vatOptions"
                            label="Значения ставки НДС"
                            placeholder="Выберите значения ставки НДС"
                        />
                        <CSelect
                            label="Единицы измерения"
                            :options="unitsOptions"
                            :value.sync="product.units"
                            placeholder="Выберите единицы измерения..."
                        />
                        <CInput
                            v-model="product.weight"
                            :label="`Вес (${UNITS_ENUM[product.units]})`"
                        />
                        <CInput
                            v-model="product.calories"
                            label="Килокалории (ккал)"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать цену "От"
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.show_min_sum"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Показывать время выполнения
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.show_lead_time"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Энергетик (18+)
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.energetic"
                                />
                                <small class="form-text text-muted">
                                    Отметьте, если продукт является энергетиком или требует подтверждения возраста 18+
                                </small>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Популярное продукт
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.popular"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Приоритет в выдаче в популярном
                            </CCol>
                            <CCol sm="3">
                                <CInput
                                    v-model="product.priority"
                                    placeholder="Приоритет"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="product.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true">Удалить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить продукт? Это действие нельзя будет отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteDish">Удалить</CButton>
                </div>
            </template>
        </CModal>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { UNITS_ENUM } from '@/utils/units';
    import { focusProductPicture } from '@/utils/focusPicture';

    export default {

        name: 'EntityProductEdit',
  
        data () {
            return {
                entity: {},
                product: {},
                selectedPicture: null,
                deleteModal: false,
                UNITS_ENUM,
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                ]
            }
        },
    
        computed: {
            pictureUrl() {
                if(this.entity.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.product.picture;
                } else {
                    return '';
                }
            },
            unitsOptions() {
                return Object.entries(UNITS_ENUM).map(([value, label]) => ({ value: +value, label }));
            },
        },
  
        mounted() {
            focusProductPicture(this.$route);
            const id = parseInt(this.$route.params.id);
            const product_id = parseInt(this.$route.params.entity_product_id);
            Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${id}/entity_products/${product_id}`)
                .then(resp => {
                    this.product = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            save() {
                if(!this.product.title) {
                    this.$root.$emit('showError', 'Укажите название продукта.');
                    return;
                }
                if(!this.product.price) {
                    this.$root.$emit('showError', 'Укажите стоимость.');
                    return;
                }
                if(!this.product.weight) {
                    this.product.weight = null;
                }
                if(!this.product.calories) {
                    this.product.calories = 0;
                }
                if(!this.product.quantity) {
                    this.product.quantity = null;
                }
                this.product.energetic = !!this.product.energetic;
                this.product.popular = !!this.product.popular;
                this.product.enabled = !!this.product.enabled;
                this.product.vat = this.product.vat ? +this.product.vat : null;

                if(this.selectedPicture) {
                    // Загружаем картинку
                    let formData = new FormData();
                    formData.append('file', this.selectedPicture);
                    Vue.axios.post('/files/upload', formData)
                        .then(resp => {
                            // Если все хорошо - сохраняем продукт
                            this.product.picture = resp.data.filename;
                            Vue.axios.post(`/entities/${this.entity.id}/entity_products/update/${this.product.id}`, this.product)
                                .then(() => {
                                    this.goBack();
                                })
                                .catch(err => {
                                    this.$root.$emit('showError', 'Ошибка сохранения.');
                                });
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки файла.');
                        });
                } else {
                    Vue.axios.post(`/entities/${this.entity.id}/entity_products/update/${this.product.id}`, this.product)
                        .then(() => {
                            this.goBack();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            deleteDish() {
                Vue.axios.delete(`/entities/${this.entity.id}/entity_products/${this.product.id}`)
                    .then(() => {
                        this.$router.push({ path: `/entities/${this.entity.entityType.code}/${this.entity.id}/products` })
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            deletePicture(url) {
                Vue.axios.delete(`/files/delete?filename=${url}`)
                    .then(() => {
                        this.product.picture = '';
                        Vue.axios.post(`/entities/${this.entity.id}/entity_products/update/${this.product.id}`, this.product)
                            .catch(err => {
                                this.$root.$emit('showError', 'Ошибка сохранения.');
                            });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({ path: `/entities/${this.entity.entityType.code}/${this.entity.id}/products/${this.product.id}` });
            }
        }
    }

</script>
<style lang="scss" scoped>

</style>
